import { QueryClient, useQuery, UseQueryOptions } from '@tanstack/react-query'
import {
  projectMapsKeys,
  RequestTypes,
} from '@core/react-query/features/projects/maps'
import { ProjectMap } from '@core/entities/project/ProjectMap'
import { RequestErrorType } from '@core/utils/api-axios-instance'

// Module-level so the reference is stable across renders — React Query
// re-runs `select` (producing a new ProjectMap) when its identity changes,
// which would make downstream effects depending on `data.layers` loop.
const selectProjectMap = (raw: unknown): ProjectMap => ProjectMap.new(raw)

export const useProjectMapConfiguration = (
  payload: RequestTypes['getProjectMapConfiguration'],
  options?: UseQueryOptions<ProjectMap, RequestErrorType>,
) => {
  return useQuery({
    select: selectProjectMap,
    ...projectMapsKeys.byProjectMapConfiguration(payload),
    ...options,
  })
}

export const prefetchProjectMapConfiguration = (
  queryClient: QueryClient,
  payload: RequestTypes['getProjectMapConfiguration'],
  options?: UseQueryOptions<ProjectMap, RequestErrorType>,
) => {
  return queryClient.prefetchQuery({
    select: selectProjectMap,
    ...projectMapsKeys.byProjectMapConfiguration(payload),
    ...options,
    cacheTime: Infinity,
  })
}
